import { fetchCompanyPalettes } from '../../services/palettes.service'
import { ActionTree } from 'vuex'
import { PalettesState } from './palettes.types'

export const actions: ActionTree<PalettesState, unknown> = {
  async fetchPalettes({ commit }) {
    try {
      const res = await fetchCompanyPalettes()
      commit('SET_ALL_PALETTES', res)
    } catch (err) {
      commit('SET_PALETTES_LOADING_ERROR', err)
    }
  }
}
